import { render, staticRenderFns } from "./RegistrationConfirm.vue?vue&type=template&id=5a659cdf&scoped=true"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=ts"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a659cdf",
  null
  
)

export default component.exports